import SplunkOtelWeb from '@splunk/otel-web';
import { getEnvironmentFromHost } from '@ace-clublabs/log-cannon';
import { splunkRUM } from './utils/constants';
const getAppVersionFromMeta = () => {
  return document?.querySelector('meta[name="version"]')?.getAttribute('content') || 'unknown-version';
};
SplunkOtelWeb.init({
  beaconUrl: splunkRUM.SPLUNK_BEACON_URL,
  rumAuth: splunkRUM.SPLUNK_RUM_AUTH,
  app: splunkRUM.SPLUNK_APP_NAME,
  version: getAppVersionFromMeta(),
  environment: getEnvironmentFromHost(),
});
